// Pure, Vue-free helpers for the Activities block. Kept in shared/ so both the
// block and unit tests import the same logic. (No ref/computed here — shared
// utilities must stay framework-free.)

export const ACTIVITY_TYPES = [
    'Boundless Connections',
    'Boundless Creativity',
    'Boundless Impact',
    'Boundless Thinking',
    'Boundless Tools',
]

export function sortActivitiesByName(activities) {
    return [...activities].sort((a, b) =>
        (a.name || '').localeCompare(b.name || '', undefined, { sensitivity: 'base' }),
    )
}

export function deriveLocations(activities) {
    const set = new Set()
    for (const a of activities) if (a.location) set.add(a.location)
    return [...set].sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }))
}

export function filterActivities(
    activities,
    { tab = 'all', type = 'all', location = 'all', favoriteIds = [] } = {},
) {
    const favSet = new Set(favoriteIds)
    const filtered = activities.filter((a) => {
        if (tab === 'favorites' && !favSet.has(a.id)) return false
        if (type !== 'all' && a.type !== type) return false
        if (location !== 'all' && a.location !== location) return false
        return true
    })
    return sortActivitiesByName(filtered)
}
